
import FullScreenDialog, { FullScreenDialogCloseReason } from "../../../components/full-screen-dialog/FullScreenDialog";
import { BindDialogReturn, DialogProps, DialogResult, DialogState, bindDialog, useDialogState } from "../../../hooks/use-dialog-state/UseDialogState";
import DataFileImportEditor from "./DataFileImportEditor";


import type { JSX } from "react";


export type DataFileImportEditorDialogInitValues = {
    //organizationID: number;
    groupID: number;
    configurationID: number;
};

export type DataFileImportEditorDialogResultValues = {
    configurationID: number | undefined;
};

export type DataFileImportEditorDialogResultReason = FullScreenDialogCloseReason | "cancel" | "save";

export type DataFileImportEditorDialogResult = DialogResult<DataFileImportEditorDialogResultValues, DataFileImportEditorDialogResultReason>;

export type DataFileImportEditorDialogProps = DialogProps<DataFileImportEditorDialogInitValues, DataFileImportEditorDialogResult>;

export default function DataFileImportEditorDialog({
    open,
    onClose,
    values
}: DataFileImportEditorDialogProps): JSX.Element {

    return (
        <FullScreenDialog open={open} onClose={reason => onClose({ reason: reason })}>

            {open && 
            <DataFileImportEditor
                groupID={values?.groupID as number}
                configurationID={values?.configurationID as number}
                onClose={({
                    reason, 
                }) => onClose({
                    reason: reason,
                    values: {
                        configurationID: values?.configurationID
                    }
                })}
            
            />
            }
        </FullScreenDialog>
    );
}

export type DataFileImportEditorDialogState = DialogState<DataFileImportEditorDialogInitValues, DataFileImportEditorDialogResult>;
export type BindDataFileImportEditorDialogReturn = BindDialogReturn<DataFileImportEditorDialogInitValues, DataFileImportEditorDialogResult>;

export function useDataFileImportEditorDialogState(): DataFileImportEditorDialogState {
    return useDialogState();
}

export function bindDataFileImportEditorDialog(props: DataFileImportEditorDialogState): BindDataFileImportEditorDialogReturn {
    return bindDialog(props);
}
